import { useState } from "react";
import { Scale } from "lucide-react";

import ValuationCalculatorForm from "@/components/ValuationCalculatorForm";
import { parseValuationQuery } from "@/lib/valuationMath";

export default function ValuationCalculator() {
  // Full width for every role — see PageShell in components/interior-page.tsx.
  const shellWidth = "w-full";
  // A shared "Copy link" scenario (or a listing hand-off) arrives as query params; read once on mount.
  const [shared] = useState(() => parseValuationQuery(window.location.search));

  return (
    <div className="public-stage pb-10">
      <div className={`${shellWidth} px-4 py-8 sm:px-6 lg:px-8`}>
        {/* Header — same Dark · Gold hero as the SBA Calculator and Deal CRM */}
        <section className="public-hero-shell mb-7 rounded-[1.85rem] px-6 py-7 shadow-glow sm:px-8">
          <div className="public-grid-lattice absolute inset-0 opacity-45" />
          <div className="absolute -right-14 top-0 h-40 w-40 rounded-full bg-white/30 blur-3xl" />
          <div className="relative z-10">
            <div className="public-pill">
              <Scale className="h-3.5 w-3.5" />
              Valuation Calculator
            </div>
            <h1 className="mt-4 font-display text-3xl leading-tight text-foreground sm:text-4xl">
              Business <span className="text-gradient">Valuation Calculator</span>
            </h1>
            <p className="mt-2 max-w-2xl text-sm leading-7 text-muted-foreground sm:text-base">
              Work out what a business is worth — SDE, adjusted EBITDA, a valuation range from industry
              multiples, and whether the asking price holds up. Updates live as you type.
            </p>
          </div>
        </section>

        <ValuationCalculatorForm initialValues={shared.values} initialIndustryId={shared.industryId} persist />
      </div>
    </div>
  );
}
